import { userModule } from '@/store/user/module'
import { organizationModule } from '@/store/organization/module'
import { instructorModule } from '@/store/instructor/module'
import { groupModule } from '@/store/group/module'
import { examModule } from '@/store/exam/module'
import { isSupportWindow } from '@/utils'

const getDismissable = (dismissableId: string) => {
    return userModule.state.dismissables[dismissableId]
}

const getCurrentUser = () => {
    return userModule.state.user
}

const intercomSettings = () => {
    const currentUser = userModule.state.user
    const organization = organizationModule.getters.getCurrentOrganization()
    const currentOrgInstructor = instructorModule.getters.getCurrentOrgInstructor()
    const sysGroups = groupModule.getters.searchCurrentOrgGroups({
        instructorId: currentOrgInstructor?.objectId,
        type: 'system',
    })
    const currentOrgExams = examModule.getters.getCurrentOrgExams()

    if (import.meta.env.VUE_APP_INTERCOM_APP_ID
        && !isSupportWindow()
        && currentUser
        && organization
        && currentOrgInstructor
        && sysGroups) {
        const examNames = sysGroups.reduce((acc, group) => {
            const examDisplayName = currentOrgExams[group.orgExam.objectId]?.displayName
            if (examDisplayName && !acc.includes(examDisplayName)) {
                acc.push(examDisplayName)
            }
            return acc
        }, [] as string[]).join(', ')

        const settings: Partial<IIntercomSettings> = {
            'app_id': import.meta.env.VUE_APP_INTERCOM_APP_ID,
            'email': currentUser.email,
            'user_id': currentUser.objectId,
            'hide_default_launcher': true,
            'Org Name': organization.name,
            'Org ID': organization.objectId,
            'Account Type': currentOrgInstructor.isAdmin ? 'Admin' : 'Instructor',
            'Exam Prep': examNames,
        }

        return settings
    } else {
        return {}
    }
}

export default {
    getDismissable,
    getCurrentUser,
    intercomSettings,
}
